import React, { useEffect, useState, ReactNode, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import { newRate } from '@tool/index';

interface IProps {
  height: number,
  xData: any[],
  yData: any[],
  bgColor?: string,
  name?: string,
}
interface IState { }

const Income = (props: IProps, state: IState) => {
  let chart: any = null;
  const navi = useNavigate();
  const { height, xData, yData, bgColor, name } = props;
  const leftChartRef = useRef<any>(null);
  const colorList = [Color.primary, Color.two, Color.secondary];

  const render = () => {
    if (chart) chart.dispose();
    chart = init(leftChartRef.current);

    const option = {
      color: colorList,
      backgroundColor: Color.fff,
      tooltip: {
        show: false,
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: (parmes: any) => {
          let htl = `<p style="font-family: 'PingFang SC'">${name || parmes[0].seriesName}</p>`;
          parmes?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                      justify-content: flex-start;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${colorList[element.seriesIndex]};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC'">${element.name}</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';padding-top:4px;flex:1;text-align:right">
                        ${isNumber(element.value) ? newRate(element.value) : '-'}
                      </span>
                    </p>`;
          });
          return htl;
        },
      },
      legend: {
        show: false,
      },
      grid: {
        left: 0,
        right: 40,
        bottom: 0,
        top: 0,
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: { color: Color.ccc },
        },
        splitNumber: 4,
        axisTick: { show: false },
        axisLabel: {
          show: true,
          formatter: (val: number) => {
            return newRate(val);
          },
          fontSize: 12,
          color: Color.da,
          fontFamily: ' Roboto',
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
      },
      yAxis: {
        type: 'category',
        data: yData,
        axisTick: { show: false },
        axisLine: {
          show: true,
          lineStyle: { color: Color.ec },
        },
        axisLabel: {
          show: true,
          interval: 0,
          fontFamily: 'Roboto',
          color: Color.blackColor(0.85),
        },
        splitArea: {
          interval: 0,
          show: true,
          areaStyle: {
            color: bgColor || Color.fff,
          },
        },
      },
      animation: false,
      series: [
        {
          name: '2011',
          type: 'bar',
          barWidth: 14,
          label: {
            show: true,
            fontFamily: 'Roboto',
            position: 'right',
            formatter: (param: any) => {
              return newRate(param.value);
            },
          },
          itemStyle: {
            borderRadius: [0, 2, 2, 0],
          },
          // showBackground: true,
          data: xData,
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [xData, yData]);

  return (
    <section ref={leftChartRef} style={{ width: '100%', height: `${height}px` }} />
  );
};

export default observer(Income);
